import orgInactiveNotificationsEntity from './entity'

export const ORG_INACTIVE_NOTIFICATIONS_CHANGE_REPEAT_DAY = 'ORG_INACTIVE_NOTIFICATIONS/CHANGE_REPEAT_DAY'
export const ORG_INACTIVE_NOTIFICATIONS_SET_BEFORE_CREATE_ID = 'ORG_INACTIVE_NOTIFICATIONS/SET_BEFORE_CREATE_ID'
export const ORG_INACTIVE_NOTIFICATIONS_SET_ID_TO_DELETE = 'ORG_INACTIVE_NOTIFICATIONS/SET_ID_TO_DELETE'

export default orgInactiveNotificationsEntity.getActionTypes()
